const chartTitles = {
  dashboard: 'Dashboard Chart',
  activity_social: 'Activities & Social',
  behaviour: 'Behaviour',
  blood_glucose: 'Blood Glucose Chart',
  blood_oxygen: 'Blood Oxygen Chart',
  blood_pressure: 'Blood Pressure Chart',
  daily: 'Daily Report',
  fluids: 'Fluids Chart',
  health_visit: 'Health Visits',
  heart_rate: 'Heart Rate Chart',
  incident: 'Incidents',
  meal: 'Food Chart',
  mobility: 'Mobility Chart',
  mood: 'Mood Chart',
  must: 'MUST Score',
  respiratory_rate: 'Respiratory Rate Chart',
  stool: 'Stool Chart',
  temperature: 'Temperature Chart',
  turns: 'Re-positioning Chart',
  wash: 'Wash Chart',
  waterlow: 'Waterlow Score Chart',
  weight: 'Weight Chart',
  painchek: 'PainChek Chart',
  seizure: 'Seizure',
}

export default chartTitles
